<template>
	<div class="honor">
		<p>COMPANY PROFILE</p>
		<h3>荣誉资质</h3>
		<div class="container">
			<div class="list">
				<div class="lists">
					<ul>
						<li v-for="item in aptitude">
							<div class="lists-li">
								<img :src="item.imgUrl"/>
							</div>
							<p>{{item.title}}</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'honor',
				aptitude:[]
			}
		},
		methods:{
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.aptitudeApi,
				})
				.then((res) => {
					this.aptitude = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getData();
		}
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../../styles/main.less");
.honor{
	P{
		.margin-top(50);
		.font-size(30);
		color: #00A0FF;
		text-align:center;
	}
	h3{
		.margin-top(10);
		.font-size(30);
		font-weight: 600;
		.margin-bottom(50);
		text-align:center;
	}
	.margin-bottom(70);
	.list{
		width: 100%;
		height: 100%;
		.title{
			width: 100%;
			background: #00A0FF;
			color: #fff;
			.padding-left(30);
			.padding-top(15);
			.padding-bottom(15);
			.font-size(30);
		}
		.lists{
			ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;
				.padding(10,10,10,10);
				li{
					display: inline-block;
					margin-bottom: 25px;
					position: relative;
					border-radius:5px;
					border:1px #eee solid;
					.margin-bottom(20);
					overflow:hidden;
					p{
						position: absolute;
						width: 100%;
						background: #00A0FF;
						bottom: 0px;
						left: 0px;
						text-align: center;
						.padding-top(20);
						.padding-bottom(20);
						.font-size(30);
						overflow:hidden;
						text-overflow:ellipsis;
						white-space:nowrap;
						.padding-left(10);
						.padding-right(10);
						color:#fff;
					}
					.lists-li{
						width: 100%;
						height: 86%;
						img{
							width: 100%;
							height: 100%;
							z-index: -1;
						}
					}					
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/About/Acom/Honor.vue